import { render, staticRenderFns } from "./EditPresale.vue?vue&type=template&id=37521226"
import script from "./EditPresale.vue?vue&type=script&lang=js"
export * from "./EditPresale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports